import React, { useState, useEffect } from "react";
import EmptyCourseDash from "../../Components/share/EmptyCourseDash/EmptyCourseDash";
import FileTable from "../../Components/layouts/AdminDashboard/FileTable";
import useFetch from "../../Hooks/useFetch";
import MainPagination from "../../Components/share/Pageination/MainPagination";
import axios from "axios";
import { BtnAlternative, BtnPrimary } from "../../Components/share/buttons/Btn";

function Files() {
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getFiles = useFetch({
        method: "GET",
        url: `UserBootCampHomeworkService/bootcamp_files/?bootcamp_id=11`,
        //pagination: pagination,
        noHeader: false,
        trigger: true,
        isNew: true,
        setter: setList,
    });
    //TODO : id bootcamp dynamic she

    useEffect(() => {
        getFiles.reFetch();
    }, [pagination]);

    return (
        <div>
            {list.length === 0 ? (
                <EmptyCourseDash name="فایل" />
            ) : (
                <div>
                    <div className=" flex SupportTicket__header justify-between items-center leading-[3.2rem] mt-[4.5rem]">
                        <h3 className=" text-[#77498F] text-[1.6rem] font-bold leading-[3.2rem] ">
                            اطلاعات فایل های بوت کمپ
                        </h3>
                    </div>
                    <FileTable list={list} />
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={list?.results}
                        pageSize={list?.page_count}
                    />
                </div>
            )}
        </div>
    );
}

export default Files;
